import React from 'react';
import {
  BookOpen,
  Award,
  Plus,
  Trash2,
  MoveUp,
  MoveDown,
  Image as ImageIcon,
  Type,
  Youtube,
  Save,
  Eye,
  EyeOff,
  Play,
  Pause,
  CheckCircle,
  LogOut,
  User as UserIcon,
  ChevronRight,
  ChevronLeft,
  ChevronsLeft,
  ChevronsRight,
  Loader2,
  Footprints,
  Star,
  Edit,
  X,
  Tag,
  Search,
  Filter,
  Upload,
  HelpCircle,
  Users,
  Shield,
  ShieldOff,
  Globe,
  DownloadCloud,
  CloudOff,
  Mail,
  Lock,
  Settings,
  StickyNote,
  Flame,
  Menu,
  List,
  Volume2,
  AlertTriangle,
  MessageSquare,
  Send,
  Clock,
  MapPin,
  Share2,
  BarChart2,
  TrendingUp,
  Gift,
  Calendar,
  Building2,
  UserPlus,
  Megaphone,
  ArrowRight,
  Phone,
  ClipboardList,
  Bell,
  Wand2,
  Sparkles
} from 'lucide-react';

export const Icons = {
  BookOpen,
  Award,
  Plus,
  Trash: Trash2,
  MoveUp,
  MoveDown,
  Image: ImageIcon,
  Text: Type,
  Youtube,
  Save,
  Eye,
  EyeOff,
  Play,
  Pause,
  Check: CheckCircle,
  Logout: LogOut,
  User: UserIcon,
  Next: ChevronRight,
  Prev: ChevronLeft,
  ChevronRight,
  ChevronLeft,
  ChevronsLeft,
  ChevronsRight,
  Loader: Loader2,
  Footprints,
  Star,
  Edit,
  X,
  Tag,
  Search,
  Filter,
  Upload,
  Quiz: HelpCircle,
  Users,
  Shield,
  ShieldOff,
  Globe,
  Download: DownloadCloud,
  Unadopt: CloudOff,
  Mail,
  Lock,
  Settings,
  Note: StickyNote,
  Flame,
  Menu,
  List,
  Audio: Volume2,
  AlertTriangle,
  MessageSquare,
  Send,
  Clock,
  Map: MapPin,
  Share: Share2,
  BarChart: BarChart2,
  TrendingUp,
  Gift,
  Calendar,
  Church: Building2,
  UserPlus,
  Megaphone,
  ArrowRight,
  Phone,
  Clipboard: ClipboardList,
  Bell,
  Wand: Wand2,
  Sparkles
};